import PropTypes from "prop-types";
import React, { useState } from "react";

import { Row, Col, CardBody, Card, Alert, Container, Form, Input, FormFeedback, Label } from "reactstrap";

//redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";
import { Link, useNavigate } from "react-router-dom";
import withRouter from "components/Common/withRouter";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

// actions
import { loginSuccess, loginUser, socialLogin } from "../../store/actions";

// import images
import profile from "assets/images/profile-img.png";
import logo from "assets/images/logo.svg";

import axios from "axios";


import { getUserIP, getUserLocation, getDeviceDetails, generateDeviceSignature } from '../../components/Common/Login/CommonHeaders';
import { loginApiURL } from "BaseComponentAPI/LoginApi";
import Spinners from "components/Common/Spinner";
import Loader from "components/Common/Loader";

const Login = props => {

  //meta title
  document.title = "Cockpit";

  const [loaderOption, setLoaderOption] = useState(false);


  const dispatch = useDispatch();
  const navigate = useNavigate();

  const validation = useFormik({
    // enableReinitialize : use this  flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      email: '',
      password: '',
    },
    validationSchema: Yup.object({
      email: Yup.string().required("Please Enter Your Email"),
      password: Yup.string().required("Please Enter Your Password"),
    }),
    onSubmit: async (values) => {
      setLoaderOption(true);
      try {
        const ip = await getUserIP(); // Function to get IP
        const location = await getUserLocation();
        const deviceDetails = getDeviceDetails();

        const combinedData = {
          userIP: ip,
          userLat: location.lat,
          userLong: location.long,
          ...deviceDetails,
        };

        const deviceSign = generateDeviceSignature(combinedData);

        const headers = {
          userIP: ip,
          userLat: location.lat,
          userLong: location.long,
          deviceSign: deviceSign,
          deviceType: deviceDetails.deviceType,
          deviceOS: deviceDetails.deviceOS,
          deviceOSVersion: deviceDetails.deviceOSVersion,
          browserName: deviceDetails.browserName,
          browserVersion: deviceDetails.browserVersion,
          renderingEngine: deviceDetails.renderingEngine,
          browserUserAgent: deviceDetails.browserUserAgent,
        };

        const response = await axios.post(
          loginApiURL,
          {
            username: values.email,
            password: values.password,
          },
          {
            headers,
          }
        );

        const nwValues = {
          "access_token": response.data.data.access_token,
          "sessionKey": response.data.data.sessionKey,
          "clientUUID": response.data.data.clientUUID,
          "userUUID": response.data.data.userUUID,
        }

        const headerValues = {
          "access_token": response.data.data.access_token,
          "sessionKey": response.data.data.sessionKey,
          "clientUUID": response.data.data.clientUUID,
          "userUUID": response.data.data.userUUID,
        }
        const combinedObject = { ...headers, ...headerValues };

        localStorage.setItem("authUser", JSON.stringify({
          email: values.email
        }));

        // console.log(props)
        // dispatch(loginUser(values, props.router.navigate));

        dispatch(loginSuccess({
          userData: response.data.data.userMenu,
          headers: combinedObject,
        }));

        // Save headers in session storage
        // sessionStorage.setItem("key-data", JSON.stringify(nwValues));
        sessionStorage.setItem("menuData", JSON.stringify(response.data.data.userMenu));
        sessionStorage.setItem("headers", JSON.stringify(combinedObject));

        // Navigate to the dashboard
        if (response.data != null || response.data.length != 0) {
          navigate("/dashboard");
        }

      } catch (error) {
        console.error("Login failed", error);
        // Handle login failure (e.g., show error message)
      } finally {
        setLoaderOption(false);
      }
    }

  });


  const LoginProperties = createSelector(
    (state) => state.Login,
    (login) => ({
      error: login.error
    })
  );

  const {
    error
  } = useSelector(LoginProperties);

  const signIn = type => {
    dispatch(socialLogin(type, props.router.navigate));
  };

  //for facebook and google authentication
  const socialResponse = type => {
    signIn(type);
  };

  //handleTwitterLoginResponse
  // const twitterResponse = e => {}

  if (loaderOption == true) {
    return (
      <>
        <Loader />
      </>
    )
  }
  else {
    return (
      <React.Fragment>
        <div className="account-pages pt-sm-5">
          <Container>
            <Row className="justify-content-center my-5">
              <Col md={8} lg={6} xl={5}>
                <Card className="overflow-hidden">
                  <div className="bg-primary-subtle">
                    <Row>
                      <Col className="col-7">
                        <div className="text-primary p-4">
                          <h5 className="text-primary">Welcome Back !</h5>
                          <p className="mt-2">Sign in to continue to Skote.</p>
                        </div>
                      </Col>
                      <Col className="col-5 align-self-end">
                        <img src={profile} alt="" className="img-fluid" />
                      </Col>
                    </Row>
                  </div>
                  <CardBody className="pt-0">
                    <div>
                      <Link to="/" className="logo-light-element">
                        <div className="avatar-md profile-user-wid mb-4">
                          <span className="avatar-title rounded-circle bg-light">
                            <img
                              src={logo}
                              alt=""
                              className="rounded-circle"
                              height="34"
                            />
                          </span>
                        </div>
                      </Link>
                    </div>
                    <div className="p-2">
                      <Form
                        className="form-horizontal"
                        onSubmit={(e) => {
                          e.preventDefault();
                          validation.handleSubmit();
                          return false;
                        }}
                      >
                        {error ? <Alert color="danger">{error}</Alert> : null}

                        <div className="mb-3">
                          <Label className="form-label">Email</Label>
                          <Input
                            name="email"
                            className="form-control"
                            placeholder="Enter email"
                            type="text"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.email || ""}
                          // invalid={
                          //   validation.touched.email && validation.errors.email ? true : false
                          // }
                          />
                          {/* {validation.touched.email && validation.errors.email ? (
                            <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
                          ) : null} */}
                        </div>

                        <div className="mb-3">
                          <Label className="form-label">Password</Label>
                          <Input
                            name="password"
                            value={validation.values.password || ""}
                            type="password"
                            placeholder="Enter Password"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            invalid={
                              validation.touched.password && validation.errors.password ? true : false
                            }
                          />
                          {validation.touched.password && validation.errors.password ? (
                            <FormFeedback type="invalid">{validation.errors.password}</FormFeedback>
                          ) : null}
                        </div>

                        <div className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="customControlInline"
                          />
                          <label
                            className="form-check-label"
                            htmlFor="customControlInline"
                          >
                            Remember me
                          </label>
                        </div>

                        <div className="mt-3 d-grid">
                          <button
                            className="btn btn-primary btn-block"
                            type="submit"
                          >
                            Log In
                          </button>
                        </div>

                        <div className="d-flex justify-content-center align-items-center">
                          <div className="mt-4 text-center">
                            <h5 className="font-size-14 mb-3">Sign in with</h5>

                            <ul className="list-inline">
                              <li className="list-inline-item">
                                <Link
                                  to="#"
                                  className="social-list-item bg-primary text-white border-primary"
                                  onClick={e => {
                                    e.preventDefault();
                                    socialResponse("facebook");
                                  }}
                                >
                                  <i className="mdi mdi-facebook" />
                                </Link>
                              </li>
                              {/*<li className="list-inline-item">*/}
                              {/*  <TwitterLogin*/}
                              {/*    loginUrl={*/}
                              {/*      "http://localhost:4000/api/v1/auth/twitter"*/}
                              {/*    }*/}
                              {/*    onSuccess={this.twitterResponse}*/}
                              {/*    onFailure={this.onFailure}*/}
                              {/*    requestTokenUrl={*/}
                              {/*      "http://localhost:4000/api/v1/auth/twitter/revers"*/}
                              {/*    }*/}
                              {/*    showIcon={false}*/}
                              {/*    tag={"div"}*/}
                              {/*  >*/}
                              {/*    <a*/}
                              {/*      href=""*/}
                              {/*      className="social-list-item bg-info text-white border-info"*/}
                              {/*    >*/}
                              {/*      <i className="mdi mdi-twitter"/>*/}
                              {/*    </a>*/}
                              {/*  </TwitterLogin>*/}
                              {/*</li>*/}
                              <li className="list-inline-item">
                                <Link
                                  to="#"
                                  className="social-list-item bg-danger text-white border-danger"
                                  onClick={e => {
                                    e.preventDefault();
                                    socialResponse("google");
                                  }}
                                >
                                  <i className="mdi mdi-google" />
                                </Link>
                              </li>
                            </ul>
                          </div>
                        </div>


                        <div className="mt-4 text-center">
                          <Link to="/forgot-password" className="text-muted">
                            <i className="mdi mdi-lock me-1" />
                            Forgot your password?
                          </Link>
                        </div>


                      </Form>
                    </div>
                  </CardBody>
                </Card>
                <div className=" mt-3 d-flex justify-content-center align-items-center">
                  <div className="text-center">
                    <p>
                      Don&#39;t have an account?{" "}
                      <Link to="/register" className="fw-medium text-primary">
                        Signup now
                      </Link>{" "}
                    </p>
                    <p>
                      © {new Date().getFullYear()}{" "}
                      <a href="https://p2k.in" target="_blank" rel="noopener noreferrer">
                        p2k.in
                      </a>{" "}
                      <i className="mdi mdi-heart text-danger" /> by Ganat Infotech
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }

};

export default withRouter(Login);

Login.propTypes = {
  history: PropTypes.object,
};


